import { render, staticRenderFns } from "./SettingsCategoryForm.vue?vue&type=template&id=0c36a17c&scoped=true&"
import script from "./SettingsCategoryForm.vue?vue&type=script&lang=js&"
export * from "./SettingsCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCategoryForm.vue?vue&type=style&index=0&id=0c36a17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36a17c",
  null
  
)

export default component.exports